const STUDENT_EXPLAINER_VIDEOS = {
	"en-us": "74079163032707d989798bfea3c3e5ba",
	"en-gb": "6cd8690c5010939dc0dd75796f3a1a09"
};

const LECTURER_EXPLAINER_VIDEOS = {
	"en-us": "f4f7258fb72581800e92652151369e8c",
	"en-gb": "cc4a539cdd649023f92b5484fdca4c6b"
};

export const USER_TESTIMONIALS = {
	"Max": "f1eee9bec614790164772258ab0bba3a",
	"Tedi": "a21804091df103b54cc2fc53d9547ccc",
	"Jaipal": "e4be80ffad17a94d702db5a34a0be0f0",
	"Zaryab": "26527b600cf98005f311d8cc59de6b6b",
};

const VIDEOS = {
	STUDENT_EXPLAINER_VIDEOS,
	LECTURER_EXPLAINER_VIDEOS,
	USER_TESTIMONIALS,
} as const;

type VideoWithLocales = "STUDENT_EXPLAINER_VIDEOS" | "LECTURER_EXPLAINER_VIDEOS";

export function get__video_for_locale(
	locale: string,
	video: VideoWithLocales,
) {
	return VIDEOS[video][locale === "en-us" ? "en-us" : "en-gb"];
}
